/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prompt_DismissInputs */



/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Notifications_Prompt_DismissInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_prompt_dismiss = /** @type {((inputs?: Notifications_Prompt_DismissInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prompt_DismissInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas maintenant")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ahora no")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Agora não")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non ora")
	return /** @type {LocalizedString} */ ("Not now")
});